var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.296 12C40.032 18.048 43.52 22.752 49.504 24.704V31.2C45.632 31.072 41.92 29.984 38.784 27.968V40.736C38.784 50.176 31.136 56 23.104 56C14.72 56 8 49.472 8 41.344C8 32.16 15.392 26.176 24.48 26.72V33.056C19.296 32.256 14.24 35.264 14.24 41.344C14.24 46.08 18.048 49.824 22.912 49.824C27.584 49.824 32.608 46.464 32.608 40.736V12H39.296Z",
    fill: "#EEEEEE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.c1157913e74db29b95c9f6ea21e4958d.svg";
export { ForwardRef as ReactComponent };